
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    adBadge: {
        display: 'inline-block',
        padding: '0.3em',
        marginRight: '5px',
        fontSize: '75%',
        fontWeight: 700,
        lineHeight: 1,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'baseline',
        borderRadius: '0.25em',
        backgroundColor: '#ffead0',
        color: '#f0ad4e'
    },
    back: {
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: '#FFF',
        padding: '15px',
        border: '1px solid #E8E8E8',
        '@media (max-width: 743px)': {
            height: '535px'
        },
        '@media (max-width: 700px)': {
            height: '510px'
        },
        '@media (max-width: 630px)': {
            height: '465px'
        },
        '@media (max-width: 565px)': {
            height: '415px'
        },
        '@media (max-width: 445px)': {
            height: '335px'
        },
        '@media (max-width: 385px)': {
            height: '295px'
        }
    },
    cardText: {
        color: '#484848',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        margin: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        display: 'inline',
        whiteSpace: 'nowrap'
    },
    containerDiv: {
        ':after': {
            content: '""',
            display: 'table',
            clear: 'both'
        }
    },
    container_fullWidth: {
        position: 'relative',
        width: '100%',
        zIndex: 0
    },
    cornerTriangle: {
        ':hover': {
            cursor: 'pointer'
        },
        zIndex: 10,
        position: 'absolute',
        right: '0px',
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 50px 50px 0',
        borderColor: 'transparent #00c8ff transparent transparent',
        opacity: 0.8,
        filter: 'alpha(opacity = 80)'
    },
    cornerTriangleBack: {
        top: '-10px'
    },
    children: {
        position: 'absolute',
        top: '0px',
        bottom: '0px',
        left: '0px',
        right: '0px',
        height: '100%',
        width: '100%'
    },
    fullWidth_fullHeight: {
        width: '100%',
        height: '100%'
    },
    linkContainer: {
        display: 'table',
        tableLayout: 'fixed',
        width: '100%',
        color: '#484848',
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'none'
        }
    },
    roomInfoContainer: {
        display: 'table-cell',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    roomInfoContainer_left: {
        width: '70%',
        '@media (max-width: 1600px)': {
            width: '60%'
        }
    },
    roomInfoContainer_right: {
        width: '30%',
        '@media (max-width: 1600px)': {
            width: '40%'
        }
    },
    switchContainer: {
        position: 'absolute',
        right: '60px',
        bottom: '5px',
        left: '60px',
        height: '135px',
        zIndex: 2001
    },
    twoLineTitle: {
        width: '100%',
        lineHeight: '18px',
        maxHeight: '36px',
        overflow: 'hidden',
        display: 'table'
    },
    reviewPlace: {
        display: 'flex'
    },
    reviewInner: {
        flex: '1 1 0%'
    },
    placeInner: {
        flex: '1 1 0%',
        textAlign: 'right',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        wordWrap: 'break-word',
        '-webkitLineClamp': '1',
        '-webkitBoxOrient': 'vertical'
    }
    // wrongVertical: {
    //     backgroundColor: 'rgba(255, 192, 26, 0.5)'
    // },
    // verticalWrapper: {
    //     display: 'flex',
    //     justifyContent: 'space-between'
    // },
    // vertical: {
    //     ':first-letter': {
    //         textTransform: 'uppercase'
    //     }
    // },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/styles.js